import { render, staticRenderFns } from "./GameOverMenu.vue?vue&type=template&id=5ca4e7e6&scoped=true&"
import script from "./GameOverMenu.vue?vue&type=script&lang=js&"
export * from "./GameOverMenu.vue?vue&type=script&lang=js&"
import style0 from "./GameOverMenu.vue?vue&type=style&index=0&id=5ca4e7e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca4e7e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VFlex,VLayout})
